import React, { FC } from "react";
import { scrollTo } from "src/utils/scroll";
import { LINK_NAV_MENU_ITEMS, SCROLL_NAV_MENU_ITEMS } from "./constants";
import { Link } from "../Link";
import Animation from "../Animations";

interface Props {
  isShown: boolean;
  onClose: () => void;
}
export const Menu: FC<Props> = ({ isShown, onClose }) => {
  if (!isShown) return null;

  const handleClick = (selector: string) => () => {
    onClose();
    scrollTo(selector);
  };

  return (
    <Animation
      variant="slide-left"
      className="absolute top-0 left-0 right-0 z-20 bg-white-base h-screen pt-20"
    >
      <aside>
        <nav className="flex flex-col justify-center items-center h-full">
          {SCROLL_NAV_MENU_ITEMS.map(({ id, href, label, selector }) => (
            <Link
              key={id}
              className="text-24 hover:scale-110 hover:text-green-base"
              href={href}
              onClick={handleClick(selector)}
              isScrollTop={false}
            >
              {label}
            </Link>
          ))}

          {LINK_NAV_MENU_ITEMS.map(({ id, href, label }) => (
            <Link key={id} className="text-24 hover:scale-110" href={href}>
              {label}
            </Link>
          ))}
        </nav>
      </aside>
    </Animation>
  );
};
